import { BasicTreeModule } from '@caslink/common-client/ng-app/basic-tree/basic-tree.module';
import { CommonModule } from '@angular/common';
import { LoadingAnimationModule } from '@caslink/common-client/ng-app/loadingAnimation/LoadingAnimationModule';
import { MonitoringTreeComponent } from './monitoring-tree.component';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
@NgModule({
    imports: [
        CommonModule,
        BasicTreeModule,
        LoadingAnimationModule,
        MatIconModule,
    ],
    declarations: [
        MonitoringTreeComponent,
    ],
    exports: [
        MonitoringTreeComponent,
    ],
})
export class MonitoringTreeModule {}
